import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'categories-side_navigation-click';

/**
 * Tracks clicks on the category page side navigation links
 */
export function trackCategoriesSideNavigationClick(
  categoryPathIdentifier: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { categoryPathIdentifier },
  });
}
